import React from 'react';
import Pagination from '../../Paginations';

const InviteSplitsTab = ({ 
  inviteSplits, 
  inviteCurrentItems, 
  inviteCurrentPage, 
  inviteTotalPages, 
  handleInvitePageChange 
}) => {
  if (inviteSplits.length === 0) {
    return (
      <div className="text-center py-5">
        <h5>No invites found</h5>
        <p>You don't have any pending split invites</p>
      </div>
    );
  }

  return (
    <>
      <div className="table-responsive mt-3">
        <table className="table dash-table">
          <thead>
            <tr>
              <td>Title</td>
              <td>ISRC</td>
              <td>Percentage</td>
              <td>Revenue</td>
            </tr>
          </thead>
          <tbody>
            {inviteCurrentItems.map((track, i) => (
              <tr key={i}>
                <td>
                  <div className="table-item">
                    {track.title}
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    {track.isrc}
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    {track.percentage}%
                  </div>
                </td>
                <td>
                  <div className="table-item">
                    ${track.revenue_share?.toFixed(2)}
                    {track.is_recoupment === true && 
                      <span className='ms-1'>(Recoupment)</span>
                    }
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination 
        currentPage={inviteCurrentPage} 
        totalPages={inviteTotalPages} 
        handlePageChange={handleInvitePageChange} 
      />
    </>
  );
};

export default InviteSplitsTab; 